<template>
  <div class="payment-log_box">
    <div>{{createdAt}}</div>
    <div>
      ￥{{totalAmount}}
    </div>
    <div>
      <router-link v-if="transferLog.matchingId"
                   :to="{ name: 'Meeting', params: {matchingId: transferLog.matchingId}}"
                   class="operator_label">
        詳細
      </router-link>
    </div>
  </div>
</template>

<script>
  import moment from "moment";

  export default {
    name: "TransferLogBox",

    props: {
      transferLog: {
        type: Object,
        required: true
      }
    },

    computed: {
      createdAt() {
        return !this.transferLog.createdAt
          ? ''
          : moment.unix(this.transferLog.createdAt.seconds).format('YYYY/MM/DD HH:mm');
      },

      totalAmount() {
        let result = 0;
        this.transferLog.result.forEach(payment => {
          result += payment.amount
        });
        return result;
      }
    },
  }
</script>


<style lang="scss" scoped>
  .payment-log_box {
    display: flex;
    justify-content: flex-start;
    border-bottom: 1px solid $border_color;

    > div {
      width: 30%;
    }
  }
</style>